import { render, staticRenderFns } from "./FormTerminos.vue?vue&type=template&id=1bdd2330&scoped=true"
import script from "./FormTerminos.vue?vue&type=script&lang=js"
export * from "./FormTerminos.vue?vue&type=script&lang=js"
import style0 from "./FormTerminos.vue?vue&type=style&index=0&id=1bdd2330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd2330",
  null
  
)

export default component.exports